<template>
  <div class="chat-wrapper" v-wechat-title="pageTitle">
    <!-- 预约状态栏 -->
    <div class="status-container" v-show="targetInfo.is_display && targetInfo.is_display == 1">
      <div class="status-bar">
        <div class="time interval" v-if="timeInterval.status==1">本次诊疗服务将在<span class="interval-timer">{{timeInterval.timer}}</span>秒后自动结束</div>
        <div class="time" v-if="targetInfo.status == 1"><span>预约时间</span> {{targetInfo.start_time | bookDateFilter}}-{{targetInfo.end_time | bookTimeFilter}}</div>
        <div class="time" v-else><span v-if="targetInfo.count">前面还有 {{targetInfo.count}} 人等待，稍后将开始诊疗</span></div>

        <div class="status ing" v-if="targetInfo.status == 3">

          <icon icon-class="talking"></icon>诊疗中
        </div>
        <div class="status order" v-else-if="targetInfo.status == 1">
          <icon icon-class="ordered"></icon>已预约
        </div>
        <div class="status waitting" v-else>
          <icon icon-class="wait"></icon>等待诊疗
        </div>

      </div>
    </div>
    <div class="chat-main" ref="wrapper">

      <div class="content" :class="{'has-topbar': targetInfo.is_display && targetInfo.is_display == 1}" ref="chatMain">
        <!-- 历史消息 -->
        <div class="chat-item" v-if="pageError">
          <div class="system-message">本页面暂不支持手动刷新，请返回诊疗室重新进入<br>
            <router-link to="/patient/chat-room">返回诊疗室</router-link>
          </div>
        </div>
        <div class="chat-item" v-if="hasHistory">
          <div class="get-history-link" @click="getHistory">更多历史消息</div>
        </div>
        <div class="chat-item" v-else-if="!hasHistory && chatData.length > 0">
          <div class="system-message">无更多历史消息</div>
        </div>

        <!-- 消息体 -->
        <div class="chat-item" v-for="item in chatData">

          <!-- 我发出的文字消息 -->
          <div class="dialogue-item mine" @touchstart="showRecallButton(item)" @touchend="clearLoop" v-if="item.messageType == 'TextMessage' && item.senderUserId == userInfo.user_id">
            <div class="dialogue-content">
              <div class="text-message" v-html="item.content.content"></div>
            </div>
            <div class="user-avatar"><img :src="userInfo.avatar" alt=""></div>
          </div>
          <!-- 我发出的图片消息 -->
          <div class="dialogue-item mine" @touchstart="showRecallButton(item)" @touchend="clearLoop" v-if="item.messageType == 'ImageMessage' && item.senderUserId == userInfo.user_id">
            <div class="dialogue-content">
              <!--@click="previewImage(item.content.imageUri)"-->
              <div class="image-message"><img :src="item.content.content" alt="" @load="loadImageFinish(item.sentTime)"></div>
            </div>
            <div class="user-avatar"><img :src="userInfo.avatar" alt=""></div>
          </div>
          <!-- 我发出的语音消息 -->
          <div class="dialogue-item mine" @touchstart="showRecallButton(item)" @touchend="clearLoop" v-if="item.messageType == 'VoiceMessage' && item.senderUserId == userInfo.user_id">
            <div class="dialogue-content voice" @click="playVoiceMessage(item)">
              <div class="voice-message" :style="item.content.duration | voiceTime">{{item.content.duration}}″
                <voice-icon direction="left" :playing="item.playing" />
              </div>
            </div>
            <div class="user-avatar"><img :src="userInfo.avatar" alt=""></div>
          </div>
          <!-- 对方发出的文字消息 -->
          <div class="dialogue-item target" v-if="item.messageType == 'TextMessage' && item.senderUserId == targetId">
            <div class="user-avatar"><img :src="targetInfo.avatar" alt=""></div>
            <div class="dialogue-content">
              <div class="text-message" v-html="item.content.content"></div>
            </div>
          </div>
          <!-- 对方发出的图片消息 -->
          <div class="dialogue-item target" v-if="item.messageType == 'ImageMessage' && item.senderUserId == targetId">
            <div class="user-avatar"><img :src="targetInfo.avatar" alt=""></div>
            <div class="dialogue-content" @click="previewImage(item.content.imageUri)">
              <div class="image-message"><img :src="item.content.content" alt="" @load="loadImageFinish(item.sentTime)"></div>
            </div>
          </div>
          <!-- 对方发出的语音消息 -->
          <div class="dialogue-item target" v-if="item.messageType == 'VoiceMessage' && item.senderUserId == targetId">
            <div class="user-avatar"><img :src="targetInfo.avatar" alt=""></div>
            <div class="dialogue-content voice" @click="playVoiceMessage(item)">
              <div class="voice-message" :style="item.content.duration | voiceTime">
                <voice-icon direction="right" :playing="item.playing" />{{item.content.duration}}″</div>
            </div>
          </div>
          <!-- 问诊单消息 -->
          <div class="dialogue-card inquiry" v-if="item.objectName == 'AnswerMsg'">
            <div class="card-header">
              <h2 class="card-title">问诊单</h2>
              <span class="card-time">{{item.content.create_time | cardTimeFilter}}</span>
            </div>
            <div class="card-content">
              <div class="content-item">
                <div class="type">患者：</div>
                <div class="text">{{item.content.username}}（{{item.content.gender | genderFilter}}
                  {{item.content.birthday | ageFilter}}）</div>
              </div>
              <div class="content-item">
                <div class="type">症状变化：</div>
                <div class="text">{{item.content.sym_change}}</div>
              </div>
              <div class="card-control"><button class="inquiry-button" @click="toQuestionnaire(item.content)">点击查看问诊单详情</button></div>
            </div>
          </div>
          <!-- 处方卡片消息 -->
          <div class="dialogue-card prescription" v-if="item.objectName == 'PreMsg'">
            <div class="card-header">
              <h2 class="card-title">处方-{{item.content.type | scriptTypeFilter}}</h2>
              <span class="card-time">{{item.content.create_time | dateFilter('day')}}</span>
            </div>
            <div class="card-content">
              <div class="content-item">
                <div class="type">患者：</div>
                <div class="text">{{item.content.username}}（{{item.content.gender | genderFilter}}
                  {{item.content.birthday | ageFilter}}）</div>
              </div>
              <div class="content-item">
                <div class="type">诊断：</div>
                <div class="text">{{item.content.diagnose}}</div>
              </div>
              <div class="prescription-tips">根据处方购买、并按时复诊</div>
              <div class="card-control"><button class="prescription-button" @click="toScript(item.content)">点击查看处方详情</button></div>
            </div>
          </div>
          <!-- 转诊卡片消息 -->
          <div class="dialogue-card reffer" v-if="item.objectName == 'ReferMsg'">
            <div class="card-header">
              <h2 class="card-title">转诊单</h2>
              <span class="card-time">{{item.content.create_time | dateFilter('day')}}</span>
            </div>
            <div class="card-content">
              <div class="content-item">
                <div class="type">患者：</div>
                <div class="text">{{item.content.username}}（{{item.content.gender | genderFilter}}
                  {{item.content.birthday | ageFilter}}）</div>
              </div>
              <div class="content-item">
                <div class="type">转诊原因：</div>
                <div class="text">{{item.content.reason}}</div>
              </div>
              <div class="card-control"><button class="reffer-button" @click="toReffer(item.content)">点击查看转诊单详情</button></div>
            </div>
          </div>
          <!-- 系统消息:消息撤回-->
          <div class="system-message" v-if="item.messageType == 'RecallCommandMessage' && parseInt(item.senderUserId)  == parseInt(userInfo.user_id)">您撤回了一条消息</div>
                <div class="system-message" v-if="item.messageType == 'RecallCommandMessage' && parseInt(item.content.targetId)==parseInt(userInfo.user_id)">对方撤回了一条消息</div>
          <!-- 系统消息:结束诊疗 -->
          <div class="system-message" v-if="item.messageType == 'CommandNotificationMessage' && item.content.name == 'FinishChat'">本次诊疗已结束</div>
          <!-- 系统消息:政府版 结束诊疗 -->
          <div class="system-message" v-if="item.messageType == 'CommandNotificationMessage' && item.content.name == 'TryFinishChat'">医生正在等待结束诊疗</div>

          <div class="system-message" v-if="item.messageType == 'CommandNotificationMessage' && item.content.name == 'cancelFinishChat'">您取消了医生的结束诊疗请求
          </div>
         <!-- 消息发送时间 -->
         <div class="chat-time" v-if="item.messageType != 'RecallCommandMessage'&&item.messageType!='CommandNotificationMessage'">{{item.sentTime | chatTimeFilter}}</div>
          <!-- 系统消息：已预约诊疗 -->
          <div class="system-message" v-if="item.messageType == 'CommandNotificationMessage' && item.content.name == 'OrderedChat'">
            <!-- 预约诊疗文案 -->
            <span v-if="item.content.data.type == 1">已预约{{item.content.data.startTime | dateFilter('month')}} -
              {{item.content.data.endTime | timeFilter}}的诊疗日程</span>
            <span v-if="item.content.data.type == 2">实时问诊发起成功</span>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-control" v-show="targetInfo.status != null">
      <!-- 正常状态下的聊天状态 -->
      <div class="normal-control" v-show="targetInfo.status > 1 && targetInfo.is_bind == 1">
        <div class="message-type-switch" @click="switchTyper">
          <icon icon-class="voice" v-if="inputType == 'text'"></icon>
          <icon icon-class="keyboard" v-else></icon>
        </div>
        <div class="message-typer">
          <flexible-text-input ref="messageInput" v-model="chatText" @focus="refreshScroller" v-if="inputType == 'text'"></flexible-text-input>
          <div class="voice-recorder" @touchstart="recorderTouchStart($event)" @touchmove="recorderTouchMove($event)"
            @touchend="recorderTouchEnd($event)" v-else>{{voiceTips}}</div>
        </div>
        <div class="send-image" @click="wxImgUpload()">
          <icon icon-class="image-tall"></icon>
        </div>
        <!--废弃  v-if="userInfo.user_id==10036" @click="wxImgUpload()"
        <div class="send-image" id="sendImage" v-else>
          <icon icon-class="image-tall"></icon>
        </div>
        -->
        <button class="send-message" v-if="inputType == 'text'" @click.prevent="sendMessage('text')" :disabled="!chatText">发送</button>
      </div>
      <div class="not-in-chat" v-show="(targetInfo.status == 1 || targetInfo.status == 0) && targetInfo.is_bind == 1">

        <button class="live-chat-button" @click="orderLiveChat">
          <icon icon-class="live-chat"></icon>发起实时问诊
        </button>
      </div>
      <div class="unbind" v-show="targetInfo.is_bind == 0">已与该医生解除绑定，无法进行问诊</div>
    </div>
    <van-popup v-model="recallBtnShow" position="bottom">
      <div class="recall-msg-panel">
        <div class="recall-tit">是否撤回该条消息?</div>
        <div class="confirm" @click="reCall()">确定</div>
        <div class="cancel" @click="recallBtnShow=false">取消</div>
      </div>
    </van-popup>
    <!-- 结束诊疗弹窗 -->
    <x-dialog v-if="tryFinishShow" title="医生正在等待结束诊疗" @close="tryFinishShow = false">
      <div class="finish-content">
        <div class="text">是否完成本次与 <span>{{targetInfo.username}}</span> 医生的诊疗</div>
        <div class="control">
          <button @click="cancelFinishChatAction" class="cancel">取消</button>
          <button @click="tryFinishChatAction" class="confirm">确定</button>
        </div>
      </div>
    </x-dialog>
    <!-- 图片预览 -->
    <van-image-preview v-model="previewShow" :images="previewList"></van-image-preview>
  </div>
</template>

<style lang="less">

  .finish-content{
    padding: 10px 0 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text{
      font-size: 16px;
      margin:5px auto;
      line-height: 16px;
      color: @black;
      font-weight: bold;
      span{
        color: @xile;
      }
    }
    .control{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        @button-base();
        height: 36px;
        font-size: 14px;
        width: 136px;
        &.cancel{
          background: #FFF;
          border: 1px solid #999;
          color: #999;
          margin-right: 15px;
        }
        &.confirm{}
      }
    }
  }
  .chat-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .recall-msg-panel{
      width: 100%;
      height: 150px;
      background-color: #fff;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      .recall-tit{
        height: 49px;
        border-bottom: solid 1px #e8e8e8;
        font-size: 14px;
        text-align: center;
        line-height: 49px;
        color:#565656;
      }
      .confirm{
        height: 49px;
        border-bottom: solid 1px #F4F4F4;
        font-size: 16px;
        text-align: center;
        line-height: 49px;
        color:#bf1515;
      }
      .cancel{
        height: 49px;
        font-size: 16px;
        text-align: center;
        line-height: 49px;
        color:#3b3b3b;
      }
    }
    .interval-timer{
      padding:1px 4px;
      color: #FF5555;

    }
    .interval{

      font-weight: 0;
      font-size: 12px;
     color:#666666;

    }
    .test{
      position: absolute;
      top: 44px;
      z-index: 99;
    }
    .status-container{
      position: absolute;
      top: 44px;
      left: 0;
      width: 100%;
      z-index: 99;
      .status-bar{
        width: 100%;
        height: 36px;
        background: #FFF;
        padding: 0 20px;
        font-size: 13px;
        color: @black;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .status{
          display: flex;
          justify-content: flex-end;
          align-items: center;
          svg{
            font-size: 14px;
            margin-right: 4px;
          }
          &.waitting{
            color: @xile;
            svg{
              color: @xile;
            }
          }
          &.order{
            color: #E2AD2E;
            svg{
              color: #E2AD2E;
            }
          }
          &.ing{
            color: #00848A;
            svg{
              color: #00848A;
            }
          }
        }
      }
    }
    .chat-main{
      position: absolute;
      top: 44px;
      left: 0;
      right: 0;
      bottom: 64px;
      background: #F7F7F7;
      overflow-y: auto;
      overflow: hidden;
      padding: 0 16px;
      .content{
        padding-bottom: 15px;
        &.has-topbar{
          padding-top: 36px;
        }
      }
      .chat-item{
        padding-top: 14px;
        .chat-time{
          text-align: center;
          font-size: 13px;
          line-height: 13px;
          color: #999;
          margin: 12px 0;
        }
        .dialogue-item{
          display: flex;
          align-items: flex-start;
          .user-avatar{
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            overflow: hidden;
            border-radius: 50%;
            background: #CCC;
            img{
              width: 100%;
            }
          }
          .dialogue-content{
            max-width: 60%;
            margin-top: 2px;
            overflow: hidden;
            .text-message{
              padding: 8px 8px 8px 10px;
              font-size: 14px;
              line-height: 20px;
              color: @black;
            }
            .image-message{
              max-width: 100%;
              max-height: 200px;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 100%;
              }
            }
            .voice-message{
              padding: 8px 8px 8px 10px;
              font-size: 14px;
              line-height: 20px;
              height: 36px;
              color: @black;
              display: flex;
              align-items: center;
              svg{
                font-size: 24px;
              }
            }
          }
          &.mine{
            justify-content: flex-end;
            .dialogue-content{
              border-radius: 12px 0 12px 12px;
              .xile-alpha(0.1);
              &.voice:active{
                .xile-alpha(0.3);
              }
              margin-right: 16px;
              .voice-message{
                justify-content: flex-end;
                svg{
                  margin-left: 10px;
                }
              }
            }
          }
          &.target{
            justify-content: flex-start;
            .dialogue-content{
              border-radius: 0 12px 12px 12px;
              background: #FFF;
              margin-left: 16px;
              &.voice:active{
                background: #EFEFEF;
              }
              .voice-message{
                justify-content: flex-start;
                svg{
                  transform: rotate(180deg);
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .get-history-link{
          text-align: center;
          font-size: 12px;
          line-height: 12px;
          color: @xile;
          margin: 12px 0;
        }
        .system-message{
          text-align: center;
          font-size: 12px;
          line-height: 16px;
          color: #999;
          margin: 12px 0;
          a{
            color: @xile;
          }
        }
        // 聊天卡片
        .dialogue-card{
          width: 90%;
          margin: 12px auto;
          padding: 0 20px;
          background: #FFF;
          border-radius: 6px;
          .card-header{
            position: relative;
            padding: 16px 0 11px;
            @dash-bottom-line();
            .card-title{
              font-size: 18px;
              line-height: 18px;
              font-weight: bold;
              margin-bottom: 7px;
            }
            .card-time{
              font-size: 12px;
              line-height: 12px;
              color: #999;
            }
          }
          .card-content{
            position: relative;
            padding-bottom: 23px;
            &::before{
              content: '';
              position: absolute;
              top: -10px;
              left: -20px;
              background: #F7F7F7;
              width: 10px;
              height: 20px;
              border-radius: 0 10px 10px 0;
              z-index: 10;
            }
            &::after{
              content: '';
              position: absolute;
              top: -10px;
              right: -20px;
              background: #F7F7F7;
              width: 10px;
              height: 20px;
              border-radius: 10px 0 0 10px;
              z-index: 10;
            }
            .content-item{
              position: relative;
              padding: 11px 0;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              @dash-bottom-line();
              font-size: 14px;
              line-height: 20px;
              color: #666;
              .type{
                flex-shrink: 0;
              }
              .text{
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
            .card-control{
              margin-top: 20px;
            }
          }
          &.inquiry{
            .card-title{
              color: @wenzhen;
            }
            .inquiry-button{
              @button-base();
              width: 100%;
              height: 36px;
              font-size: 14px;
              background: @wenzhen;
            }
          }
          &.prescription{
            .card-title{
              color: @xile;
            }
            .prescription-tips{
              margin-top: 16px;
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
            .prescription-button{
              @button-base();
              width: 100%;
              height: 36px;
              font-size: 14px;
              background: @xile;
            }
          }
          &.reffer{
            .card-title{
              color: #00848A;
            }
            .reffer-tips{
              margin-top: 16px;
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
            .reffer-button{
              @button-base();
              width: 100%;
              height: 36px;
              font-size: 14px;
              background: #00848A;
            }
          }
        }
      }
    }
    .chat-control{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #FFF;
      box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.04);
      .normal-control{
        padding: 12px 16px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .message-type-switch{
          width: 36px;
          height: 36px;
          background: #FFF;
          margin: 2px 0;
          border-radius: 50%;
          border: 1px solid #999;
          color: #333;
          display: flex;
          justify-content: center;
          align-items: center;
          svg{
            font-size: 26px;
          }
        }
        .message-typer{
          flex: 1;
          margin-left: 8px;
          margin-right: 8px;
          // height: 40px;
          .message-input{
            width: 100%;
            line-height: 20px;
            padding: 10px 12px;
            color: #666;
            border: 0;
            background: #F3F3F3;
            border-radius: 4px;
            transition: all .2s;
            outline: none;
            max-height: 80px;
            overflow-y: auto;
            &:focus{
              // background: #FFF;
            }
          }
          .voice-recorder{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40px;
            width: 100%;
            color: #666;
            border: 0;
            background: #F3F3F3;
            border-radius: 4px;
            transition: all .2s;
            max-height: 80px;
            &:active{
              background: #DDDDDD;
            }
          }
        }
        .send-image{
          margin: 2px 8px 2px 0;
          flex-shrink: 0;
          width: 36px;
          height: 36px;
          border: 1px solid #999;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          svg{
            font-size: 24px;
            color: @black;
          }
        }
        .send-message{
          @button-base();
          width: 64px;
          height: 36px;
          margin: 2px 0;
          transition: all .2s;
          &:disabled{
            opacity: .6
          }
        }
      }
      .not-in-chat{
        height: 64px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        button{
          @button-base();
          height: 40px;
          svg{
            font-size: 20px;
            margin-right: 4px;
          }
          &.reservation-button{
            width: 128px;
          }
          &.live-chat-button{
            @button-border();
            flex: 1;
            margin-left: 11px;
          }
        }
      }
      .unbind{
        height: 64px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.04);
        font-size: 14px;
        line-height: 20px;
        color: #999;
        background: #FFF;
      }
    }
  }
</style>


<script type="text/javascript">
  import Bscroll from 'better-scroll'
  import flexibleTextInput from '@/components/Common/flexibleTextInput'
  import voiceIcon from '@/components/Common/voiceIcon'
  import xDialog from '@/components/Common/dialog'

  export default {
    data() {
      return {
        timeInterval: {
          tip: null,
          timer: 60,
          status: 0,
        },
        finishChatOneMinText: "",
        tryFinishShow: false,
        // 页面title
        pageTitle: '诊疗室',
        // 医生名字头像信息&患者状态
        targetInfo: {},
        // 页面由于手动刷新导致的错误
        pageError: false,
        // 聊天类型
        conversationType: RongIMLib.ConversationType.PRIVATE,
        // 聊天信息发送的目标id
        targetId: '',
        // 聊天滚动区域高度
        aheight: '',
        // 聊天记录数据
        chatData: [],
        // 是否有更多历史消息
        hasHistory: false,
        // 获取历史消息滚动高度记录
        oldHeight: 0,
        newHeight: 0,
        scrollHeight: 0,
        historyLastTime: null,
        // 文字消息
        chatText: '',
        // 图片上传实例
        imageUploader: null,
        // 图片预览列表
        previewList: [],
        previewShow: false,
        // 聊天底部输入框类型 text: 文字输入 voice: 语音输入
        inputType: 'text',
        voiceTips: '按住说话',
        // 语音输入监听触摸事件
        touchPosition: {
          start: 0,
          move: 0,
          end: 0,
        },
        // 录音起始时间
        recordStartTime: null,
        recordEndTime: null,
        // 录音提示toast
        voiceToast: null,
        // 录音flag
        recorderFlag: 0,
        // 最长录音1分钟的计时器
        recordTimer: 60,
        autoCloseRecorder: null,

        // 语音播放
        playingId: null,
        voicePlayTimer: null,
        voiceRecordingHtml: `<div class="recording-icon-box">
                                <svg class="iconfont-svg" aria-hidden="true">
                                  <use xlink:href="#icon-recording"></use>
                                </svg>
                                <div class="voice-virtualization">
                                  <div class="voice-bar"></div>
                                </div>
                              </div>
                              <p>手指上滑，取消发送</p>`,
        wxUploadArray: [],
        wxUploadServerArray: [],
        recallBtnShow: false,
        recallMsgEntry: null,
        recallPanelType: ''
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      flexibleTextInput,
      xDialog,
      voiceIcon
    },
    created() {
      //this.tryFinishShow=true;
      // 重连服务重置消息监听
      RongIMClient.getInstance().logout();
      this.initChatClient();
      this.targetId = this.$route.params.id;
      let _this = this;

      // 清除此会话的未读消息
      setTimeout(() => {
        RongIMClient.getInstance().clearUnreadCount(this.conversationType, this.targetId, {
          onSuccess(res) {},
          onError(err) {}
        })
      }, 2000);
      // 获取微信sdk签名
      let url = encodeURIComponent(window.location.href.split('#')[0])
      console.log(url)
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['startRecord', 'stopRecord', 'onVoiceRecordEnd', 'uploadVoice', 'translateVoice',
              'chooseImage', 'uploadImage'
            ]
          });
        }
      })

      // 获取对方的名称头像以及诊疗状态
      this.$root.post('/getChatUserInfo', {
        pat_id: this.userInfo.user_id,
        doc_id: this.targetId,
        type: 2,
      }).then(data => {
        this.pageTitle = `${data.username}医生`;
        this.targetInfo = data;
        console.log(data)
        this.$nextTick(() => {
          this.scroll.refresh();
          this.scroll.scrollTo(0, this.scroll.maxScrollY);
        })
      })
    },
    mounted() {
      document.body.className = 'full-height';
      this.$nextTick(() => {
        this.scroll = new Bscroll(this.$refs.wrapper, {
          click: true,
          scrollbar: true
        })
        window.addEventListener('resize', () => {
          this.scroll.refresh();
        })
      })

      let _this = this;
      // 进页面第一次拉历史消息timestamp要设置为0
      RongIMClient.getInstance().getHistoryMessages(this.conversationType, this.targetId, 0, 20, {
        onSuccess(list, hasMsg) {
          console.log('加载历史消息')
          console.log(list)
          // 页面刷新导致的数据错误显示“返回诊疗室”的提示
          if (list.length == 0 && !hasMsg) {
            _this.pageError = true;
          }
          _this.hasHistory = hasMsg ? true : false;
          var dataList=list;
          /*
          for(var j=0;j<list.length;j++){
            if (list[j].messageType != 'RecallCommandMessage') {
               dataList.push(list[j])
            }
          }
*/
          _this.voiceHanlder(dataList);
          _this.chatData = dataList;
          _this.historyLastTime = dataList.length > 0 ? dataList[dataList.length - 1].sentTime : new Date().getTime();
          _this.$nextTick(() => {
            _this.scroll.refresh();
            _this.oldHeight = _this.newHeight = _this.$refs.chatMain.clientHeight;
            _this.scrollHeight = _this.scroll.maxScrollY;
            _this.scroll.scrollTo(0, _this.scrollHeight);
          });
        }
      })
      // 初始化图片上传
      //废弃
      //this.setUpload(this.imageUploader, 'sendImage');
    },
    beforeDestroy() {
      document.body.className = '';
    },
    methods: {
      showRecallButton(item) {
        let _this = this;
        //if (this.userInfo.user_id == 10036) {
          clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
          this.Loop = setTimeout(function() {
            var current = Number(new Date());
            let min = ((current - item.sentTime) / 1000) / 60

            if (min <= 1) {
              _this.recallBtnShow = true;
              _this.recallMsgEntry = item;
            } else {
              _this.$notify("1分钟以内发送的消息可以撤回");
            }
          }, 1000);

        //}
      },
      clearLoop() {
        clearInterval(this.Loop);

      },
      reCall() {
        let _this = this;
        let recalMsg = _this.recallMsgEntry;
        RongIMClient.getInstance().sendRecallMessage(recalMsg, {
          onSuccess: function(message) {
            _this.chatData.forEach(function(item, index, arr) {
              if (item.messageUId == recalMsg.messageUId) {
                arr.splice(index, 1);
              }
            });
               _this.chatData.push(message);
            //_this.sendRecallMsgCommand(recalMsg.messageUId);
            //console.log('撤回成功', message);
          },
          onError: function(errorCode) {
            console.log('撤回失败', errorCode);
          }
        });
        _this.recallBtnShow = false;
      },
      sendRecallMsgCommand(msg_uid) {
        let _this = this;
        let msg = new RongIMLib.CommandNotificationMessage({
          name: 'RecallMessage',
          data: {
            msg_uid: msg_uid,
            sender_id: _this.userInfo.user_id
          }
        });

        RongIMClient.getInstance().sendMessage(this.conversationType, this.targetId, msg, {
          onSuccess(message) {
            _this.chatData.push(message);
            _this.$nextTick(() => {
              _this.scroll.refresh();
              _this.scroll.scrollTo(0, _this.scroll.maxScrollY, 200);
            });
          },
          onError(errorCode, message) {
            console.log(errorCode);
          }
        })
      },
      // 初始化IM
      initChatClient() {
        let _this = this;
        // 设置会话信息监听器
        let messageListener = {
          receiveNewMessage(message) {
            if (parseInt(message.targetId) == _this.targetId) {
              _this.chatData.push(message);
              // 结束诊疗消息需要变更状态
              if (message.messageType == 'CommandNotificationMessage' && message.content.name == 'FinishChat') {
                _this.targetInfo.is_display = 0;
                _this.targetInfo.status = 4;
                _this.targetInfo.status = 0;
              }
              if (message.messageType == 'CommandNotificationMessage' && message.content.name == 'TryFinishChat') {
                //结束诊疗倒计时
                _this.finishChatEvent();
              }

              if (message.messageType == 'RecallCommandMessage') {
                let msgUid = message.content.messageUId;
                _this.chatData.forEach(function(item, index, arr) {
                  if (item.messageUId == msgUid) {
                    arr.splice(index, 1);
                  }
                });
              }
              // 如果是等待诊疗状态则变换为诊疗中
              if (_this.targetInfo.status == 2) {
                _this.targetInfo.status = 3;
              }

              // 给语音消息添加播放状态
              if (message.messageType == 'VoiceMessage') {
                // message.playing = false;
                _this.$set(message, 'playing', false);
              }

              _this.$nextTick(() => {
                _this.scroll.refresh();
                _this.scroll.scrollTo(0, _this.scroll.maxScrollY, 200);
              });

            }
          },
          connectSuccess() {
            // console.log('页面内链接成功');
          }
        }
        this.$root.IMInit(this.userInfo.token, messageListener);
      },
      cancelFinishChatAction() {
        this.tryFinishShow = false;
        this.sendTryFinishSystemMessage("cancelFinishChat");
      },
      tryFinishChatAction() {
        let _this = this;
        this.tryFinishShow = false;

        _this.timeInterval.status = 0;
        clearInterval(_this.timeInterval.tip);
        _this.timeInterval.timer = 60;
        _this.timeInterval.tip = null;
        //改变诊疗状态
        _this.targetInfo.is_display = 0;
        _this.targetInfo.status = 4;
        _this.targetInfo.status = 0
        _this.$nextTick(() => {
          _this.scroll.refresh();
          _this.scroll.scrollTo(0, _this.scroll.maxScrollY, 200);
        });
      },
      finishChatEvent() {
        let _this = this;
        //双向握手，医生尝试结束诊疗
        _this.tryFinishShow = true;

        _this.timeInterval.status = 1;
        _this.timeInterval.tip = setInterval(() => {
          let _timer = parseInt(_this.timeInterval.timer);
          if (_timer > 0) {
            _this.timeInterval.timer = _timer - 1;
          } else {
            _this.timeInterval.status = 0;
            clearInterval(_this.timeInterval.tip);
            _this.timeInterval.timer = 60;
            _this.timeInterval.tip = null;
            //改变诊疗状态
            _this.targetInfo.is_display = 0;
            _this.targetInfo.status = 4;
            _this.targetInfo.status = 0
            _this.$nextTick(() => {
              _this.scroll.refresh();
              _this.scroll.scrollTo(0, _this.scroll.maxScrollY, 200);
            });
          }
        }, 1000);
      },
      sendTryFinishSystemMessage(msgContent) {
        let _this = this;
        // 定义通用命令通知消息
        let msg = new RongIMLib.CommandNotificationMessage({
          name: msgContent,
          data: {
            status: 1
          }
        });
        RongIMClient.getInstance().sendMessage(this.conversationType, this.targetId, msg, {
          onSuccess(message) {
            _this.chatData.push(message);
            if (msgContent == "FinishChat") {
              _this.targetInfo.is_display = 0;
              _this.targetInfo.status = 4;
              //_this.targetInfo.status = 0;
            }
            // 刷新滚动区域，将位置置于底部
            _this.$nextTick(() => {
              _this.scroll.refresh();
              _this.scroll.scrollTo(0, _this.scroll.maxScrollY, 200);
              // 诊疗结束后隐藏顶部状态条
              //政府版等待患者确认再隐藏顶部状态条
              //  _this.targetInfo.is_display = 0;
              // _this.scroll.refresh();

            })
          },
          onError(errorCode, message) {
            console.log(errorCode);
          }
        })
      },
      wxSyncUpload() {
        let _this = this;
        if (_this.wxUploadArray.length == 0) {
          //console.log(_this.wxUploadServerArray);
          _this.$root.post('/getWxImgBatch', {
            oss_dir: 'chat',
            batch_arr: _this.wxUploadServerArray,
            type: 1
          }).then(data => {
            if (data.status == 1) {
              _this.$toast.clear();
              //console.log(data.resultArr.length)
              if (data.resultArr.length > 0) {
                // console.log(data.resultArr.length)
                var sendArr = data.resultArr;
                sendArr.forEach(item => {
                  let msg = new RongIMLib.ImageMessage({
                    content: item.url,
                    imageUri: item.url
                  });
                  //console.log(msg)
                  RongIMClient.getInstance().sendMessage(_this.conversationType, _this.targetId, msg, {
                    onSuccess(message) {
                      _this.$toast.clear();
                      _this.chatData.push(message);
                      _this.sendMessageCallBack(message);
                      //console.log(message);
                    }
                  })
                });
              }

            } else {
              _this.$notify('发送图片失败');
            }
          });


        } else {
          var localId = _this.wxUploadArray.shift();
          wx.uploadImage({
            localId: localId,
            isShowProgressTips: 0,
            success: function(res) {
              _this.wxUploadServerArray.push(res.serverId);
              //console.log("上传第" + localId + '张')
              _this.wxSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: 3, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxUploadArray = res.localIds;
            _this.wxSyncUpload();
            _this.$toast.loading({
              duration: 0,
              forbidClick: true,
              loadingType: 'spinner',
              message: '发送中...'
            })
          }
        });

      },
      // 设置上传图片的函数
      // 上传并发送图片
      setUpload(obj, id) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "Image files", extensions: "jpg,jpeg,png"}
            // ],
            // mime_types: "image/*",
            prevent_duplicates: true,
          },
          // 单文件上传
          multi_selection: false,
          init: {
            FilesAdded(up, files) {
              files.forEach(file => {
                if (file.type.indexOf("image/") == -1) {
                  _this.$notify('图片格式不正确');
                  up.removeFile(file)
                  return false;
                }
              })
              _this.$root.setUploadParam(up, '', false);
            },
            // 上传前设置文件名
            BeforeUpload(up, file) {
              _this.$toast.loading({
                duration: 0,
                forbidClick: true,
                loadingType: 'spinner',
                message: '发送中...'
              })
              _this.$root.setUploadParam(up, file.name, true);
            },
            // 上传完成
            FileUploaded(up, file, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                let base64Str = res.thumb;
                let imageUri = res.url;
                let msg = new RongIMLib.ImageMessage({
                  content: base64Str,
                  imageUri: imageUri
                });
                RongIMClient.getInstance().sendMessage(_this.conversationType, _this.targetId, msg, {
                  onSuccess(message) {
                    _this.$toast.clear();
                    _this.chatData.push(message);
                    _this.sendMessageCallBack(message);
                  }
                })
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 图片加载完成后刷新scroll area
      loadImageFinish(timestamp) {
        this.$nextTick(() => {
          // 如果是本次会话新发的图片，则直接滚动至最下面
          if (timestamp > this.historyLastTime) {
            this.scroll.refresh();
            this.scroll.scrollTo(0, this.scroll.maxScrollY);
            return;
          }
          // 计算滚动条位置 如果为获取更多历史记录，实时计算新高度，如果为第一次加载，直接滚动到底部
          if (this.newHeight != this.oldHeight) {
            this.newHeight = this.$refs.chatMain.clientHeight;
            this.scrollHeight = -(this.newHeight - this.oldHeight);
          } else {
            this.scrollHeight = this.scroll.maxScrollY;
          }
          this.scroll.refresh();
          this.scroll.scrollTo(0, this.scrollHeight);
        })
      },
      // 消息发送成功后的统一处理函数
      sendMessageCallBack(message) {
        console.log(message)
        // 发送消息至api
        this.$root.post('/addChatLog', {
          send_id: this.userInfo.user_id,
          to_id: this.targetId,
          type: messageType(message.messageType),
          channel_type: 1,
          content: JSON.stringify(message),
          create_time: parseInt(message.sentTime / 1000),
        }).then(data => {})
        // 消息类型转换为数据库格式
        function messageType(type) {
          switch (type) {
            case 'TextMessage':
              return 1;
              break;
            case 'ImageMessage':
              return 2;
              break;
            case 'VoiceMessage':
              return 3;
              break;
          }
        }
        // 刷新滚动区域，将位置置于底部
        this.$nextTick(() => {
          this.scroll.refresh();
          this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
        })
      },
      // 获取更多历史消息
      getHistory() {
        this.oldHeight = this.$refs.chatMain.clientHeight;
        let _this = this;
        let timestamp = this.chatData[0] ? this.chatData[0].sentTime : 0;
        RongIMClient.getInstance().getHistoryMessages(this.conversationType, this.targetId, timestamp, 20, {
          onSuccess(list, hasMsg) {
            _this.hasHistory = hasMsg ? true : false;
            var dataList=list;
            /*
            for(var j=0;j<list.length;j++){
              if (list[j].messageType != 'RecallCommandMessage') {
                 dataList.push(list[j])
              }
            }
            */
            _this.voiceHanlder(dataList);
            _this.chatData.unshift(...dataList);
            _this.$nextTick(() => {
              // 获取新的滚动区域高度计算显示位置，将滚动高度定在获取历史消息之前
              _this.newHeight = _this.$refs.chatMain.clientHeight;
              _this.scrollHeight = -(_this.newHeight - _this.oldHeight);
              _this.scroll.refresh();
              _this.scroll.scrollTo(0, _this.scrollHeight);
            });
          }
        })
      },
      // 从列表中筛选出语音消息添加播放状态
      voiceHanlder(list) {
        list.forEach(message => {
          if (message.messageType == 'VoiceMessage') {
            message.playing = false;
          }
        })
      },
      // 发送文字消息
      sendMessage() {
        let _this = this;
        // 发送文字信息
        let msg = new RongIMLib.TextMessage({
          content: this.chatText
        });
        RongIMClient.getInstance().sendMessage(this.conversationType, this.targetId, msg, {
          onSuccess(message) {
            _this.chatData.push(message);

            _this.chatText = '';
            // 消除输入第一个字母光标漂移的问题
            _this.$nextTick(() => {
              _this.$refs.messageInput.clearComponentText();
            })
            _this.sendMessageCallBack(message);
          },
          onError(errorCode, message) {
            console.log(errorCode);
          }
        })
      },
      // 播放语音消息
      playVoiceMessage(item) {
        console.log(item);
        let voice = item.content.content
        if (!voice) {
          this.$notify('未获取到语音消息')
        } else {
          if (item.messageUId == this.playingId) {
            // 如果点击的是正在播放的语音，则停止这条语音
            RongIMLib.RongIMVoice.stop(voice);
            this.playingId = null;
            item.playing = false;
            clearTimeout(this.voicePlayTimer);
          } else {
            // 已有一条语音正在播放,则取消正在播放的语音，播放新点击的语音
            if (this.playingId != null) {
              console.log(this.playingId)
              this.chatData.forEach(message => {
                if (this.playingId == message.messageUId) {
                  RongIMLib.RongIMVoice.stop(message.content.content);
                  this.playingId = null;
                  message.playing = false;
                  clearTimeout(this.voicePlayTimer);
                }
              })
            }
            // 设置播放状态，同时播放语音
            this.playingId = item.messageUId;
            RongIMVoice.preLoaded(voice, () => {
              item.playing = true;
              let duration = item.content.duration * 1000;
              // 播放完成后自动取消播放状态
              this.voicePlayTimer = setTimeout(() => {
                this.playingId = null;
                item.playing = false;
              }, duration);
              RongIMVoice.play(voice, item.content.duration);
            })
          }
        }
      },
      // 刷新scroller
      refreshScroller() {
        this.scroll.refresh();
        this.scroll.scrollTo(0, this.scroll.maxScrollY);
      },
      // 预览聊天界面的图片
      previewImage(url) {
        this.previewList = [url];
        this.previewShow = true;
      },
      // 切换输入类型
      switchTyper() {
        if (this.inputType == 'text') {
          this.inputType = 'voice';
        } else {
          this.inputType = 'text';
        }
      },
      // 语音输入交互逻辑
      recorderTouchStart(e) {
        e.preventDefault();
        // 标记flag
        this.recorderFlag = -1;
        this.touchPosition.start = 0;
        this.touchPosition.start = e.targetTouches[0].pageY;
        this.voiceTips = '松开结束';
        this.recordStartTime = new Date().getTime();
        // 设置定时器，录音60秒自动结束录音进行上传
        this.autoCloseRecorder = setInterval(() => {
          this.recordTimer--;
          if (this.recordTimer === 0) {
            this.recorderTouchEnd(e);
          }
        }, 1000);
        this.voiceToast = this.$toast({
          duration: 0,
          type: 'html',
          className: 'voice-recording',
          message: this.voiceRecordingHtml
        })
        let _this = this;
        wx.startRecord({
          fail(err) {
            clearInterval(this.autoCloseRecorder);
            _this.$notify(`开始录音报错${JSON.stringify(err)}`);
          }
        })
      },
      recorderTouchMove(e) {
        e.preventDefault();
        this.touchPosition.move = 0;
        this.touchPosition.move = e.targetTouches[0].pageY;
        if (Math.abs(this.touchPosition.start - this.touchPosition.move) < 70) {
          this.voiceTips = '松开结束';
          this.voiceToast.className = 'voice-recording';
          this.voiceToast.message = '手指上划，取消发送';
          this.voiceToast.type = 'html';
          this.voiceToast.icon = '';
          this.voiceToast.message = this.voiceRecordingHtml;
        } else {
          this.voiceToast.className = 'recording-toast-warning';
          this.voiceToast.message = '松开手指，取消发送';
          this.voiceToast.icon = 'withdraw';
          this.voiceToast.type = 'text';
          this.voiceToast.iconPrefix = 'iconfont icon',
            this.voiceTips = '松开手指，取消发送';
        }
      },
      // 停止录音后的操作
      stopRecordAction(localId) {
        if (Math.abs(this.touchPosition.start - this.touchPosition.end) < 70) {
          // 关闭提示
          this.voiceToast.clear();
          // 显示上传提示
          this.$toast.loading({
            duration: 0,
            forbidClick: true,
            loadingType: 'spinner',
            message: '语音发送中...'
          });
          // 上传语音文件至微信服务器，由服务端下载返回base64数据，然后上传至融云
          let _this = this;
          wx.uploadVoice({
            localId: localId,
            isShowProgressTips: 1,
            success(result) {
              var serverId = result.serverId;
              _this.$root.post('/getMedia', {
                id: serverId,
                type: 1
              }).then(data => {
                _this.$toast.clear();
                if (data.status == 1) {
                  // 发送语音消息到融云
                  let msg = new RongIMLib.VoiceMessage({
                    content: data.content,
                    duration: data.time
                  });
                  RongIMClient.getInstance().sendMessage(_this.conversationType, _this.targetId, msg, {
                    onSuccess(message) {
                      _this.chatData.push(message);
                      _this.$set(message, 'playing', false);
                      _this.sendMessageCallBack(message);
                    },
                    onError(errorCode, message) {
                      _this.$notify('发送语音失败' + errorCode);
                    }
                  })
                } else {
                  _this.$notify('发送语音失败');
                }
              })
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传语音报错${JSON.stringify(err)}`);
            }
          })
        } else {
          this.voiceToast.clear();
        }
      },
      recorderTouchEnd(e) {
        this.recorderFlag = -(this.recorderFlag);
        if (this.recorderFlag > 0) {
          e.preventDefault();
          this.touchPosition.end = 0;
          this.touchPosition.end = e.changedTouches[0].pageY;
          this.voiceTips = '按住说话';
          this.recordTimer = 60;
          clearInterval(this.autoCloseRecorder);
          this.recordEndTime = new Date().getTime();
          // 计算录音时间
          let duration = ((this.recordEndTime - this.recordStartTime) / 1000).toFixed(0);
          // 小于2秒不作处理，提示说话时间太短
          if (duration < 2) {
            if (Math.abs(this.touchPosition.start - this.touchPosition.end) < 70) {
              this.$notify('说话时间太短');
            }
            wx.stopRecord();
            this.voiceToast.clear();
          } else {
            let _this = this;
            // 停止录音，如果不是已取消的语音则上传至微信服务器
            wx.stopRecord({
              success(res) {
                let localId = res.localId;
                _this.stopRecordAction(localId);
              },
              fail(err) {
                _this.voiceToast.clear();
                if (err.errMsg == 'stopRecord:tooshort') {
                  _this.$notify('说话时间太短');
                } else {
                  _this.$notify('服务器发生错误');
                }
              }
            })
          }
        } else {
          return false;
        }
      },
      // 问诊单页面跳转
      toQuestionnaire(item) {
        this.$router.push({
          name: 'QuestionnaireDetail',
          params: {
            id: item.id
          }
        });
      },
      // 处方详情页面跳转
      toScript(item) {
        this.$router.push({
          name: 'PrescriptionDetail',
          params: {
            id: item.id
          }
        });
      },
      toReffer(item){
          console.log(item);
          this.$router.push({
            name: 'ReferralDetail',
            params: {
              id: item.id
            }
          })
      },
      // 点击预约问诊去医生详情页
      toDoctorDetail() {
        this.$router.push({
          name: 'PatientDoctorDetail',
          params: {
            id: this.targetId
          }
        });
      },
      // 点击实时问诊跳转实时问诊付款页
      orderLiveChat() {
        this.$root.post('/isAllowEnroll', {
          pat_id: this.userInfo.user_id,
          doc_id: this.$route.params.id,
        }).then(data => {
          if (data.status == 1) {
            this.$router.push({
              path: '/patient/order/payment',
              query: {
                doc_id: this.$route.params.id,
                type: 2
              }
            });
          } else {
            this.$notify(data.msg);
          }
        })
      }
    },
    filters: {
      chatTimeFilter(value) {
        return moment(value).format('YYYY年MM月DD日 HH:mm');
      },
      cardTimeFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD');
      },
      bookDateFilter(stamp) {
        return moment.unix(stamp).format('MM.DD HH:mm');
      },
      bookTimeFilter(stamp) {
        return moment.unix(stamp).format('HH:mm');
      },
      voiceTime(value) {
        if (!value) {
          return {
            width: 'auto'
          };
        } else {
          let time = parseInt(value);
          if (time >= 60) {
            return {
              width: 65 + time * 2 + 'px'
            };
          } else if (time < 60 && time >= 30) {
            return {
              width: 65 + time * 2.5 + 'px'
            };
          } else if (time < 30 && time >= 10) {
            return {
              width: 65 + time * 3 + 'px'
            };
          } else {
            return {
              width: 63 + time * 3.5 + 'px'
            };
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/ConsultingRoom/chat.vue